<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="cont" title="Contents">
<p class="fm1"><span class="right_1" epub:type="pagebreak" id="page_vi" title="vi"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii">Contents</span></span></p>
<p class="toc" id="int"><a href="#/text/Introduction#rint">Me: An Introduction</a></p>
<p class="toc1" id="pt1"><a href="#/text/Part1#rpt1">FLOCK</a></p>
<p class="toc" id="ch1"><a href="#/text/Chapter1#rch1">The Home Place</a></p>
<p class="toc" id="ch2"><span href="#/text/Chapter2#rch2" title="Link target outside of Sample">Mamatha Takes Flight</span></p>
<p class="toc" id="ch3"><span href="#/text/Chapter3#rch3" title="Link target outside of Sample">A Good Name</span></p>
<p class="toc" id="ch4"><span href="#/text/Chapter4#rch4" title="Link target outside of Sample">A Field Guide to the Four</span></p>
<p class="toc" id="ch5"><span href="#/text/Chapter5#rch5" title="Link target outside of Sample">First-Sunday God</span></p>
<p class="toc1" id="pt2"><span href="#/text/Part2#rpt2" title="Link target outside of Sample">FLEDGLING</span></p>
<p class="toc" id="ch6"><span href="#/text/Chapter6#rch6" title="Link target outside of Sample">Little Brown Icarus</span></p>
<p class="toc" id="ch7"><span href="#/text/Chapter7#rch7" title="Link target outside of Sample">Whose Eye Is on the Sparrow</span></p>
<p class="toc" id="ch8"><span href="#/text/Chapter8#rch8" title="Link target outside of Sample">Cows</span></p>
<p class="toc" id="ch9"><span href="#/text/Chapter9#rch9" title="Link target outside of Sample">Life’s Spring</span></p>
<p class="toc1" id="pt3"><span href="#/text/Part3#rpt3" title="Link target outside of Sample">FLIGHT</span></p>
<p class="toc" id="ch10"><span href="#/text/Chapter10#rch10" title="Link target outside of Sample">The Bluebird of Enlightenment</span></p>
<p class="toc" id="ch11"><span href="#/text/Chapter11#rch11" title="Link target outside of Sample">Hoops</span></p>
<p class="toc" id="ch12"><span href="#/text/Chapter12#rch12" title="Link target outside of Sample">Birding While Black</span></p>
<p class="toc" id="ch13"><span href="#/text/Chapter13#rch13" title="Link target outside of Sample">Jawbone</span></p>
<p class="toc" id="ch14"><span href="#/text/Chapter14#rch14" title="Link target outside of Sample">New Religion</span></p>
<p class="toc" id="ch15"><span href="#/text/Chapter15#rch15" title="Link target outside of Sample">Thinking</span></p>
<p class="toc" id="ch16"><span href="#/text/Chapter16#rch16" title="Link target outside of Sample">Digging</span></p>
<p class="toc" id="ch17"><span href="#/text/Chapter17#rch17" title="Link target outside of Sample">Family Reunion</span></p>
<p class="toc" id="ch18"><span href="#/text/Chapter18#rch18" title="Link target outside of Sample">Patchwork Legacy</span></p>
<p class="toca" id="ack"><span href="#/text/Acknowledgement#rack" title="Link target outside of Sample">Acknowledgments</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?71155400